import React, { useCallback, useEffect, useRef, useState } from "react";
import Icon from "../YourAIAgents/components/components/icon";
import { useUsersContext } from "../../context/usersContext";
import useDebouncedEffect from "../../hook/debounce";
import { useNavigate } from "react-router-dom";
import formatTime from "../../utils/formatTime";
import { format } from "date-fns";
import { CircularProgress } from "@mui/material";

const filterItems = (items, searchQuery) => {
  if (!searchQuery.trim()) return items;

  const query = searchQuery.toLowerCase();
  return items.filter((item) =>
    `${item.title} ${item.description}`.toLowerCase().includes(query),
  );
};

const truncateWords = (text = "", wordLimit = 19) => {
  const words = text && text?.split(" ");
  return words?.length > wordLimit
    ? `${words.slice(0, wordLimit).join(" ")}...`
    : text;
};

const Search = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const loaderRef = useRef();
  const [activeTab, setActiveTab] = useState("all");
  const { fetchSearchContent, searchPageContent } = useUsersContext();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];
      if (target.isIntersecting && searchPageContent.hasMore && !loading) {
        setPage((prev) => prev + 1);
      }
    },
    [searchPageContent, loading],
  );

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "200px",
      threshold: 0,
    };
    if (searchPageContent.hasMore && !loading) {
      const observer = new IntersectionObserver(handleObserver, option);

      if (loaderRef.current) {
        observer.observe(loaderRef.current);
      }
      return () => observer.disconnect();
    }
  }, [handleObserver]);

  const fetchContent = async () => {
    setLoading(true);
    await fetchSearchContent(searchQuery, page);
    setLoading(false);
  };

  useDebouncedEffect(
    () => {
      fetchContent();
    },
    [searchQuery, page],
    500,
  );
  return (
    <div className="w-full h-full overflow-hidden flex justify-center">
      <div className="newUI_container overflow-y-auto !h-full v3chat__input">
        <h1 className="newUI_title">Search</h1>

        <div className="newUI_search_bar_section">
          <div className="newUI_search_input_box">
            <div className="newUI_search_icon">
              <Icon id="v3_search" />
            </div>
            <input
              className="newUI_search_input w-full"
              placeholder="Search anything..."
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </div>

          {/* <select
            className="newUI_filter_select"
            value={activeTab}
            onChange={(event) => setActiveTab(event.target.value)}
          >
            <option value="all">All</option>
            <option value="chat">Chats</option>
            <option value="task">Tasks</option>
            <option value="assistant">Agents</option>
          </select> */}
        </div>

        {/* {(activeTab === "all" || activeTab === "task") &&
          tasks.map((task) => (
            <div key={task.id} className="newUI_result_card">
              <div
                style={{ backgroundColor: "#F2FFED", color: "#757575" }}
                className="newUI_badge newUI_task_badge"
              >
                Task
              </div>
              <div>
                <h3>{truncateWords(task.title)}</h3>
                <p>{truncateWords(task.description)}</p>
              </div>
            </div>
          ))} */}

        {loading && (!searchPageContent?.hasMore || page === 1) ? (
          <div className="w-full h-full flex flex-col gap-3 items-center justify-center">
            <CircularProgress size={40} />
            <p className="text-[12px]">Loading data, please wait...</p>
          </div>
        ) : (
          (activeTab === "all" || activeTab === "chat") &&
          searchPageContent?.data?.map((chat) => (
            <div
              key={chat.id}
              className="newUI_result_card"
              onClick={() => navigate(`/app/chat/${chat?.conversation_id}`)}
            >
              <div
                style={{ color: "#757575" }}
                className="newUI_badge newUI_chat_badge"
              >
                Chat
              </div>
              <div>
                <h3 style={{ color: "black" }}>
                  {truncateWords(chat?.name, 9)}
                </h3>
                <p>
                  {truncateWords(
                    typeof chat?.lastMessage === "string"
                      ? chat?.lastMessage
                      : "",
                  )}
                </p>
              </div>
              <span className="newUI_meta">
                Last Message{" "}
                {format(new Date(chat.lastMessageTime), "dd-MM-yy")} at{" "}
                {format(new Date(chat.lastMessageTime), "hh:mm a")}
              </span>
            </div>
          ))
        )}
        <div ref={loaderRef} className="h-[40px] text-center w-full">
          {loading && (searchPageContent?.hasMore || page > 1) && "Loading..."}
        </div>

        {/* {(activeTab === "all" || activeTab === "assistant") &&
          assistants.map((assistant) => (
            <div key={assistant.id} className="newUI_result_card">
              <div
                style={{ backgroundColor: "#B9ECFF", color: "#757575" }}
                className="newUI_badge newUI_assistant_badge"
              >
                Agent
              </div>
              <div>
                <h3>{truncateWords(assistant.title)}</h3>
                <p>{truncateWords(assistant.description)}</p>
              </div>
            </div>
          ))} */}
      </div>
    </div>
  );
};

export default Search;
